import React, { useEffect, useState } from 'react';
import './coursesHoverCard.css';
import C2wcourseCardHoverDateinfo from './C2wCourseCountHoverinfo';
import C2wCourseCountHover from './courseCountHover';
import { useNavigate } from 'react-router';
import { AITOOLBOOTCAMP2, OFFLINECOURSE, UPCOMING_COURSE, FULLSTACK_COURSE } from '../../../_utils/Routes';

function C2wCoursesHoverCard({ obj = null }) {
  const navigate = useNavigate();
  const rendredCoursesCountsCards = obj?.topicArray?.map((objCount, idx) => {
    return <C2wCourseCountHover key={idx} obj={objCount} />;
  });

  const generateSlug = (name) => {
    return name?.replace(/\s+/g, '-') ?? '';
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className='C2wCoursesHoverCard_ctn'
      onClick={() => {
        if (obj?.slug === 'full-stack-development' || obj?.type === 'Fullstack') {
          navigate(FULLSTACK_COURSE);
        } else if (obj?.slug && (obj.slug.startsWith('/') || obj.slug.includes('/'))) {
          navigate(`/${obj.slug.replace(/^\//, '')}`);
        } else if (obj?.type === 'Online') {
          navigate(`/courses/${generateSlug(obj?.slug)}`);
        } else if (obj?.type === 'AI') {
          navigate(`${AITOOLBOOTCAMP2}`);
        } else if (obj?.type === 'Upcoming') {
          if (obj?.slug === 'full-stack-development' || obj?.courseTitle?.toLowerCase().includes('full stack')) {
            navigate(FULLSTACK_COURSE);
          } else {
            navigate(`${UPCOMING_COURSE}/${generateSlug(obj?.slug)}`);
          }
        } else {
          navigate(`${OFFLINECOURSE}/${generateSlug(obj?.slug)}`);
        }
      }}
    >
      <div className='C2wCoursesHoverCard_top_thumb'>
        <img
          className='C2wCoursesHoverCard_ctn_thumnnail_img'
          src={`/assets/images/courses/${obj?.thumbnailImage}`}
          alt='course-img'
        />
        <div className='C2wCoursesHoverCard_feesdiv'>
          {`₹ ${obj?.fees}`}
          <div className='C2wCoursesHoverCard_line'></div>
          <div className='C2wCoursesHoverCard_feesDivGST'>
            {obj?.type === 'AI' ? `${'Incl. GST'}` : obj?.gst ? `+ ${obj?.gst}% GST` : null}
          </div>
        </div>
      </div>

      <div className='C2wCoursesHoverCard_hover_ctn'>
        <C2wcourseCardHoverDateinfo title={obj?.admissionType} validity={obj?.validityType} />
        <div className='C2wCourseCard_hover_Count_ctn'>{rendredCoursesCountsCards}</div>
      </div>
    </div>
  );
}

export default C2wCoursesHoverCard;
